export default "__VITE_ASSET__DvR89d5I__"